import React from "react";
import { ChevronLeft } from "@carbon/icons-react";

const FieldItem = ({ label, value, isFullWidth = false }) => (
  <div className={isFullWidth ? "uk-width-1-1" : ""}>
    <div className="uk-margin">
      <label
        className="uk-form-label"
        style={{
          fontSize: "11px",
          color: "#999",
          textTransform: "uppercase",
          fontWeight: "600",
          letterSpacing: "0.5px",
          marginBottom: "8px",
          display: "block",
        }}
      >
        {label}
      </label>
      <p
        style={{
          fontSize: "15px",
          color: "#333",
          fontWeight: "500",
          margin: "0",
          lineHeight: "1.6",
          wordBreak: "break-word",
        }}
      >
        {value || "-"}
      </p>
    </div>
  </div>
);

const CampaignRecipientResponseDetail = ({ response, onBack }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div className="dashboardWrp">
      <div className="uk-container">
        <div className="uk-grid" uk-grid="">
          <div className="uk-width-1-1">
            <div className="uk-margin-medium-bottom">
              <button
                className="uk-button uk-button-secondary back-btn"
                onClick={onBack}
              >
                <ChevronLeft size={18} />
                Back to Recipients
              </button>
            </div>

            <div
              className="uk-card uk-card-default"
              style={{
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                borderRadius: "8px",
                border: "1px solid #e5e5e5",
              }}
            >
              <div
                className="uk-card-header"
                style={{
                  backgroundColor: "#fafafa",
                  borderBottom: "2px solid #e5e5e5",
                  padding: "24px 32px",
                }}
              >
                <h3
                  className="uk-card-title uk-margin-remove"
                  style={{
                    fontSize: "22px",
                    fontWeight: "600",
                    color: "#333",
                  }}
                >
                  Recipient Response Details
                </h3>
              </div>

              <div className="uk-card-body" style={{ padding: "32px" }}>
                {/* Recipient Information Section */}
                <div style={{ marginBottom: "32px" }}>
                  <h4
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#333",
                      marginBottom: "20px",
                      paddingBottom: "10px",
                      borderBottom: "2px solid #e5e5e5",
                    }}
                  >
                    Recipient Information
                  </h4>
                  <div
                    className="uk-grid uk-grid-medium uk-child-width-1-2@m"
                    uk-grid=""
                    style={{ marginTop: "0" }}
                  >
                    <FieldItem
                      label="Customer Email"
                      value={response?.customer?.email}
                    />
                    <FieldItem
                      label="Customer Phone"
                      value={response?.customer?.phone}
                    />
                    <FieldItem
                      label="Order Number"
                      value={response?.order?.orderNo}
                    />
                    <FieldItem
                      label="Survey Code"
                      value={response?.surveyCode}
                    />
                    <FieldItem
                      label="Status"
                      value={
                        <span
                          style={{
                            display: "inline-block",
                            padding: "4px 14px",
                            borderRadius: "16px",
                            fontSize: "12px",
                            fontWeight: "600",
                            textTransform: "capitalize",
                            backgroundColor:
                              response?.status === "completed"
                                ? "#28a745"
                                : response?.status === "pending"
                                ? "#ffc107"
                                : "#6c757d",
                            color:
                              response?.status === "pending" ? "#000" : "#fff",
                          }}
                        >
                          {response?.status || "N/A"}
                        </span>
                      }
                    />
                    <FieldItem
                      label="Is Accessed"
                      value={response?.isAccessed ? "Yes" : "No"}
                    />
                    <FieldItem
                      label="Is Completed"
                      value={response?.isCompleted ? "Yes" : "No"}
                    />
                    <FieldItem
                      label="Is Expired"
                      value={response?.isExpired ? "Yes" : "No"}
                    />
                    {response?.accessedAt && (
                      <FieldItem
                        label="Accessed At"
                        value={formatDate(response?.accessedAt)}
                      />
                    )}
                    <FieldItem
                      label="Expires At"
                      value={formatDate(response?.expiresAt)}
                    />
                  </div>
                </div>

                {/* Survey Response Section */}
                {response?.response && response?.isCompleted && (
                  <div style={{ marginBottom: "32px" }}>
                    <h4
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#333",
                        marginBottom: "20px",
                        paddingBottom: "10px",
                        borderBottom: "2px solid #e5e5e5",
                      }}
                    >
                      Survey Response
                    </h4>
                    <div
                      className="uk-grid uk-grid-medium uk-child-width-1-2@m"
                      uk-grid=""
                      style={{ marginTop: "0" }}
                    >
                      {response?.response?.overallRating && (
                        <FieldItem
                          label="Overall Rating"
                          value={response?.response?.overallRating}
                        />
                      )}
                      <FieldItem
                        label="Submitted At"
                        value={formatDate(response?.response?.submittedAt)}
                        isFullWidth={true}
                      />
                    </div>
                  </div>
                )}

                {/* Access Information Section */}
                <div>
                  <h4
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#333",
                      marginBottom: "20px",
                      paddingBottom: "10px",
                      borderBottom: "2px solid #e5e5e5",
                    }}
                  >
                    Access Information
                  </h4>
                  <div
                    className="uk-grid uk-grid-medium uk-child-width-1-1@m"
                    uk-grid=""
                    style={{ marginTop: "0" }}
                  >
                    <FieldItem
                      label="Survey Code"
                      value={response?.surveyCode}
                      isFullWidth={true}
                    />
                    <FieldItem
                      label="Access URL"
                      value={
                        <a
                          href={response?.accessUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#0f62fe", wordBreak: "break-all" }}
                        >
                          {response?.accessUrl}
                        </a>
                      }
                      isFullWidth={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignRecipientResponseDetail;
